<template>
    <div class="page">
        <v-container class="py-6">
            <v-card class="px-4 py-1 card-shadow">
                <v-card-title>اعرف أكثر عنّا</v-card-title>
                <v-card-subtitle>اعرف أكثر عن منصة خانة</v-card-subtitle>
                <v-card-text class="pb-6">
                    <div style="white-space: pre-wrap; color: #222; font-size: 15px; line-height: 1.8;">{{appData.about_page_text}}</div>
                </v-card-text>
            </v-card>
        </v-container>

        <slot v-if="!isAuthed" name="footer" />
    </div>
</template>
<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    computed: {
        ...GlobalComputed,
    }
}
</script>